var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3653_8496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04058 6.83593L3.99995 4.79531L1.95933 6.83593C1.73901 7.05625 1.38433 7.05625 1.16401 6.83593C0.943701 6.61562 0.943701 6.26093 1.16401 6.04062L3.20464 4L1.16401 1.95937C0.943701 1.73906 0.943701 1.38437 1.16401 1.16406C1.38433 0.943747 1.73901 0.943747 1.95933 1.16406L3.99995 3.20468L6.04058 1.16406C6.26089 0.943747 6.61558 0.943747 6.83589 1.16406C7.0562 1.38437 7.0562 1.73906 6.83589 1.95937L4.79526 4L6.83589 6.04062C7.0562 6.26094 7.0562 6.61562 6.83589 6.83593C6.61558 7.05468 6.25933 7.05468 6.04058 6.83593Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3653_8496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/closeSmall.3f074c00f67b8baffef26ceb9e4ad02b.svg";
export { ForwardRef as ReactComponent };